<ng-container *transloco="let t; read: 'configuration'">
<drdp-container>
  <div class="pl-1 w-1/5">
    @if (currentPeriods.length == 0) {
      <h1 class="text-xl font-bold border-b">
        {{ t('globalRatingPeriods.addTermDates') }}
      </h1>
    }
    @if (currentPeriods.length) {
      <h1 class="text-xl font-bold border-b">
        {{ t('globalRatingPeriods.termDates') }}
      </h1>
    }
  </div>
  @if (currentPeriods.length == 0) {
    <div>
      <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="formTableColumns"
        (editActionItem)="dateChange($event)">
      </drdp-add-edit-table>
    </div>
  }
  @if (currentPeriods.length) {
    <div>
      <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="formTableColumns">
      </drdp-add-edit-table>
    </div>
  }
  <div class="flex justify-end items-en mt-5">
    @if (currentPeriods.length == 0) {
      <div>
        <drdp-btn [disabled]="!(validForm$ | async)" (click)="confirmSave()">{{ t('common.save') }}</drdp-btn>
      </div>
    }
    @if (currentPeriods.length && !agenciesApplied) {
      <div>
        <drdp-btn [disabled]="noSubmit" (click)="confirmSubmit()">{{ t('common.submit') }}</drdp-btn>
      </div>
    }
  </div>
</drdp-container>
</ng-container>
